module.exports = __webpack_public_path__ + "static/media/gigi.ba8b8b29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/squadBackgroundImg/gigi.jpg
// module id = 716
// module chunks = 0